import { types, destroy, getSnapshot, getPathParts } from 'mobx-state-tree'
import { values } from 'mobx'
import Customer from './Customer'
import Job from './Job'
import Material from './Material'
import WorkOrder from './WorkOrder'
import Employee from './Employee';
import Activity from './Activity';
import StandardOperation from './StandardOperation';
import { isBefore } from 'date-fns';
// import localforage from 'localforage';
import { db } from '../index'

// const customerStore = localforage.createInstance({
//   name: 'customers'
// })

// const employeeStore = localforage.createInstance({
//   name: 'employees'
// })

// const jobStore = localforage.createInstance({
//   name: 'jobs'
// })

// const materialStore = localforage.createInstance({
//   name: 'materials'
// })

// const standardOperationStore = localforage.createInstance({
//   name: 'standardOperations'
// })

// const workOrderStore = localforage.createInstance({
//   name: 'workOrders'
// })

export const RootStore = types
  .model({
    isLoading: false,
    loadingCollections: types.optional(types.array(types.string), []),
    // isLoadingActivities: true,
    // isLoadingCustomers: true,
    // isLoadingEmployees: true,
    // isLoadingJobs: true,
    // isLoadingMaterials: true,
    // isLoadingStandardOperations: true,
    // isLoadingWorkOrders: true,
    activities: types.optional(types.map(Activity), {}),
    customers: types.optional(types.map(Customer), {}),
    employees: types.optional(types.map(Employee), {}),
    jobs: types.optional(types.map(Job), {}),
    materials: types.optional(types.map(Material), {}),
    standardOperations: types.optional(types.map(StandardOperation), {}),
    workOrders: types.optional(types.map(WorkOrder), {}),
  })
  .actions(self => {
    let dbRef;
    return {
      afterCreate() {
        // onPatch(self.employees, patch => {
        //   console.log(patch)
        // })
      },
      load(user) {
        if (!user) return
        self.isLoading = true
        const { uid } = user
        db.collection('users').doc(uid).get()
          .then(doc => {
            if (doc.exists) {
              // console.log(doc.data())
              const environmentId = doc.data().environmentId
              dbRef = db.collection('environments').doc(environmentId)
              const collections = [
                'activities',
                'customers', 
                'employees', 
                'jobs', 
                'materials', 
                'standardOperations',
                'workOrders',
              ]
              collections.forEach(collection => {
                self.startLoadingCollection(collection)
                dbRef.collection(collection).onSnapshot(snapshot => {
                  self.stopLoadingCollection(collection)
                  self.unsetLoadingFlag()
                  snapshot.forEach(doc => self.setCollectionItemFromSnapshot(collection, doc.data()))
                })
              })
            } else {
              console.warn('User doc does not exist')
            }
          })
          .catch(err => console.warn('Error getting user document:', err))

        // setTimeout(() => {
        //   customerStore.iterate((value, key, iterationNumber) => {
        //     self.setCollectionItemFromSnapshot('customers', value)
        //   }).then(() => { self.setIsLoadingCustomers(false) });
        // }, 500)
        // employeeStore.iterate((value, key, iterationNumber) => {
        //   self.setCollectionItemFromSnapshot('employees', value)
        // }).then(() => { self.setIsLoadingEmployees(false) });
        // setTimeout(() => {
        //   jobStore.iterate((value, key, iterationNumber) => {
        //     self.setCollectionItemFromSnapshot('jobs', value)
        //   }).then(() => { self.setIsLoadingJobs(false) });
        // }, 500);
        // materialStore.iterate((value, key, iterationNumber) => {
        //   self.setCollectionItemFromSnapshot('materials', value)
        // }).then(() => { self.setIsLoadingMaterials(false) });
        // standardOperationStore.iterate((value, key, iterationNumber) => {
        //   self.setCollectionItemFromSnapshot('standardOperations', value)
        // }).then(() => { self.setIsLoadingStandardOperations(false) });
        // workOrderStore.iterate((value, key, iterationNumber) => {
        //   self.setCollectionItemFromSnapshot('workOrders', value)
        // }).then(() => { self.setIsLoadingWorkOrders(false) });
      },
      unsetLoadingFlag() { self.isLoading = false },
      startLoadingCollection(collection) { self.loadingCollections.push(collection) },
      stopLoadingCollection(collection) { 
        self.loadingCollections.splice(self.loadingCollections.indexOf(collection), 1)
      },
      setCustomer(id, snapshot) {
        self.customers.set(id, snapshot)
      },
      loadCustomer(id) {
        if (dbRef) {
          dbRef.collection('customers').doc(id).get()
            .then(doc => {
              if (doc.exists) self.setCollectionItemFromSnapshot('customers', doc.data())
            })
        }
        // setTimeout(() => {
        //   customerStore.getItem(id).then(value => {
        //     self.setCollectionItemFromSnapshot('customers', value)
        //   })
        // }, 500);
      },
      loadJob(id) {
        if (dbRef) {
          dbRef.collection('jobs').doc(id).get()
            .then(doc => {
              if (doc.exists) self.setCollectionItemFromSnapshot('jobs', doc.data())
            })
        }
        // setTimeout(() => {
        //   jobStore.getItem(id).then(value => {
        //     self.setCollectionItemFromSnapshot('jobs', value)
        //   })
        // }, 1500);
      },
      // setIsLoadingCustomers(value) { self.isLoadingCustomers = value },
      // setIsLoadingEmployees(value) { self.isLoadingEmployees = value },
      // setIsLoadingJobs(value) { self.isLoadingJobs = value },
      // setIsLoadingMaterials(value) { self.isLoadingMaterials = value },
      // setIsLoadingStandardOperations(value) { self.isLoadingStandardOperations = value },
      // setIsLoadingWorkOrders(value) { self.isLoadingWorkOrders = value },
      // addWorkOrder(w) {
      //   self.workOrders.set(w.id, w)
      // },
      setCollectionItemFromSnapshot(collection, snapshot) {
        self[collection].set(snapshot.id, snapshot)
      },
      addNewItemToCollection(collection, snapshot) {

      },
      // addCustomer(customer) { self.customers.set(customer.id, customer) },
      removeModel(model) { destroy(model) },
      saveItem(item) {
        const pathParts = getPathParts(item)
        // console.log(pathParts)
        dbRef.collection(pathParts[0]).doc(pathParts[1])
          .set(getSnapshot(item), { merge: true })
      }
    }
  })
  .views(self => ({
    get employeesAsOptions() {
      return values(self.employees).map(e => {
        return { key: e.id, value: e.id, text: e.name }
      })
    },
    isLoadingCollection(collection) {
      return self.loadingCollections.indexOf(collection) > -1
    },
    getUndeliveredWorkOrders(search) {
      return values(self.workOrders)
        .filter(w => {
          if (w.dateDelivered) return false
          if (!search) return true
          const needle = search.toLowerCase()
          if (w.job && w.job.jobNumber.toLowerCase().indexOf(needle) > -1) return true
          if (w.job && w.job.description.toLowerCase().indexOf(needle) > -1) return true
          if (w.customer && w.customer.name.toLowerCase().indexOf(needle) > -1) return true
          return false
        })
        .sort((a,b) => {
          if (a.dateDeliveryRequired > b.dateDeliveryRequired) return 1
          if (a.dateDeliveryRequired < b.dateDeliveryRequired) return -1
          if (a.dateRequiredReady > b.dateRequiredReady) return 1
          if (a.dateRequiredReady < b.dateRequiredReady) return -1
          return 0
        })
    },
    getMaterials(search = '', filter = '') {
      return values(self.materials)
        .filter(m => {
          if (filter && m.units !== filter) return false
          return m.description.toLowerCase().indexOf(search.toLowerCase()) > -1
        })
    },
    getCustomers(search = '') {
      return values(self.customers)
        .filter(customer => customer.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
        .sort((a,b) => {
          if (a.name > b.name) return 1
          if (a.name < b.name) return -1
          return 0
        })
    },
    getStandardOperations(search) {
      return values(self.standardOperations)
        .filter(s => s.description.toLowerCase().indexOf(search.toLowerCase()) > -1)
        .sort((a,b) => {
          if (a.description > b.description) return 1
          if (a.description < b.description) return -1
          return 0
        })
    },
    getActivities(fromDate, toDate, employeeId = null, workOrderNumber = null) {
      const activities = values(self.activities).filter(a => {
        if (workOrderNumber) return a.workOrder.workOrderNumber === workOrderNumber
        if (employeeId) return a.employee.id === employeeId
        return true
      }).sort((a,b) => {
        return isBefore(a.startedAt, b.startedAt) ? 1 : -1
      })
      return activities
    },
    getJobs(search = '', status = 'all') {
      return values(self.jobs)
        .filter(job => {
          if (status === 'withJobNumber') {
            if (!job.jobNumber) return false
          }
          if (status === 'withoutJobNumber') {
            if (job.jobNumber) return false
          }
          const needle = search.toLowerCase()
          if (job.jobNumber && job.jobNumber.toLowerCase().indexOf(needle) > -1) return true
          if (job.description.toLowerCase().indexOf(needle) > -1) return true
          if (job.usualCustomer) return job.usualCustomer.name.toLowerCase().indexOf(needle) > -1
          return false
        })
        .sort((a,b) => {
          if (a.dateCreated > b.dateCreated) return -1
          if (a.dateCreated < b.dateCreated) return 1
          return 0
        })
    },
    getWorkOrders(string, status = 'All') {
      return values(self.workOrders)
        .filter(wo => {
          switch (status) {
            case 'unfinished':
              if (wo.isReady) return false
              break
            case 'ready':
              if (!wo.isReady) return false
              if (wo.isDelivered) return false
              break
            case 'delivered':
              if (!wo.isDelivered) return false
              break
            case 'All':
            default:
              // do nothing
          }
          if (!string) return true
          const needle = string.toLowerCase()
          if (wo.job && wo.job.jobNumber.toLowerCase().indexOf(needle) > -1) return true
          if (wo.job && wo.job.description.toLowerCase().indexOf(needle) > -1) return true
          if (wo.customer && wo.customer.name.toLowerCase().indexOf(needle) > -1) return true
          return false
        })
        .sort((a,b) => {
          if (a.workOrderNumber > b.workOrderNumber) return -1
          if (a.workOrderNumber < b.workOrderNumber) return 1
          return 0
        })
    },
    getEmployees(search = '') {
      return values(self.employees)
      .filter(e => e.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
      .sort((a,b) => {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
    },
    nextWorkOrderNumber() {
      const arrayOfNumbers = values(self.workOrders).map(i => i.workOrderNumber)
      const currentMax = Math.max(...arrayOfNumbers)
      return currentMax > 0 ? currentMax + 1 : 1
    }
  }))



// WEBPACK FOOTER //
// ./src/models/RootStore.js